(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4957],{

/***/ 4957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Footer003": function() { return /* binding */ Footer003; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var components_Footer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51712);
/* harmony import */ var components_Forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93590);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52853);
/* harmony import */ var _Footer003_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28894);
/* harmony import */ var _Footer003_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Footer003_module_scss__WEBPACK_IMPORTED_MODULE_5__);






var Footer003 = function(param) {
    var payload = param.payload;
    var ref;
    var formType = (ref = payload === null || payload === void 0 ? void 0 : payload.formType) !== null && ref !== void 0 ? ref : {};
    var ref1;
    var template = (ref1 = payload === null || payload === void 0 ? void 0 : payload.template) !== null && ref1 !== void 0 ? ref1 : "light";
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_3__/* .buildWidgetInstanceId */ .G1)("003", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_4__/* .WIDGETS_REGISTRY.FOOTER */ .R.FOOTER);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Footer__WEBPACK_IMPORTED_MODULE_1__/* .FooterWidgetWrapper */ .b, {
        className: (_Footer003_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[template],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Forms__WEBPACK_IMPORTED_MODULE_2__/* .Form */ .l0, {
            item: formType,
            instanceId: instanceId
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer003);


/***/ }),

/***/ 28894:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grey":"Footer003_grey__zXF3w","light":"Footer003_light__bET8Y"};

/***/ })

}]);